var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "diagram-line min-w-0",
      attrs: { "data-qa": "diagram_line" },
    },
    [
      _c("div", { staticClass: "d-flex align-center gc-4 min-w-0" }, [
        _vm.label
          ? _c(
              "div",
              {
                staticClass: "diagram-line__label text-body-1 flex-shrink-0",
                attrs: { "data-qa": "diagram_line_label" },
              },
              [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "diagram-line__track flex-grow-1 min-w-0" }, [
          _c(
            "div",
            { staticClass: "diagram-line__row d-flex align-center gc-2 w-100" },
            [
              _c("div", {
                staticClass: "diagram-line__progress flex-shrink-0",
                style: { width: _setup.progressBarWidth },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "diagram-line__value text-subtitle-1 flex-shrink-0",
                  attrs: { "data-qa": "diagram_line_percent" },
                },
                [
                  _vm._v(
                    "\n          " + _vm._s(_setup.percent) + "%\n        "
                  ),
                ]
              ),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }